import { SlidersIcon } from './icons'
import { navigate } from '../lib/router'
import { useOnline } from '../lib/online'

export function Header({ title, subtitle }: { title: string; subtitle?: string }) {
  const online = useOnline()
  return (
    <header className="pt-safe sticky top-0 z-20 border-b border-line bg-bg">
      <div className="mx-auto flex h-14 max-w-lg items-center gap-3 px-4">
        <div className="min-w-0 flex-1">
          <h1 className="truncate text-[19px] leading-tight font-semibold tracking-tight">{title}</h1>
          {subtitle ? <p className="truncate text-[12px] text-faint tnum">{subtitle}</p> : null}
        </div>
        {!online ? (
          <span className="rounded-full border border-line-strong px-2 py-0.5 text-[11px] font-medium tracking-wide text-dim uppercase">
            Offline
          </span>
        ) : null}
        <button
          type="button"
          onClick={() => navigate('settings')}
          aria-label="Settings"
          className="-mr-2 flex size-10 items-center justify-center rounded-lg text-dim transition-colors duration-150 active:bg-raised active:text-text"
        >
          <SlidersIcon />
        </button>
      </div>
    </header>
  )
}
